<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索登錄賬號|名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="比賽名稱">
							<el-input size="small" v-model="from.title" placeholder="搜索比賽名稱"></el-input>
						</el-form-item>
						<el-form-item label="試卷編號">
							<el-input size="small" v-model="from.topic_no" placeholder="搜索試卷編號"></el-input>
						</el-form-item>
						<el-form-item label="用戶名稱">
							<el-input size="small" v-model="from.name" placeholder="搜索用戶名稱"></el-input>
						</el-form-item>

						<el-form-item label="類型">
							<el-select v-model="from.is_check_status" size="small" placeholder="請選擇類型">
								<el-option label="已處理" :value="1"></el-option>
								<el-option label="未打分" :value="0"></el-option>
							</el-select>
						</el-form-item>
            
						<el-form-item label="創建時間"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="開始日期"
							      end-placeholder="結束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" >
				<el-table-column align="center" prop="user_name" label="用戶" width="100"></el-table-column>
        <el-table-column align="center" prop="topic_no" label="試卷編號" width="180"></el-table-column>

		<el-table-column align="center" prop="title" label="比賽">
								<template slot-scope="scope">
									{{ scope.row.title }}
								</template>
					</el-table-column>

        <el-table-column align="center" prop="grade_name" label="年級" width="100"></el-table-column>
        <el-table-column align="center" prop="total" label="題目數量" width="100"></el-table-column>
        <el-table-column align="center" prop="use_time" label="使用時間" width="180">
					<template slot-scope="scope">{{ formatUseTime(scope.row.use_time) }}</template>
				</el-table-column>
        
		<el-table-column align="center" prop="set_score" label="獲得分數" width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.is_check_status == 1">{{scope.row.set_score}}</span>
                    <span v-else style="color: red;">未打分</span>
                  </template>
                </el-table-column>

				<el-table-column align="center" prop="start_time" label="開始時間" width="180"></el-table-column>
        <el-table-column align="center" prop="end_time" label="結束時間" width="180"></el-table-column>
				<el-table-column prop="id" align="center" width="120" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								size="mini"
								plain
                				type="primary"
								v-auth="'edit' + auth_val"
								@click="getScore(scope.row)"
							>
								查看試卷
							</el-button>
						
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

     
		<el-dialog :close-on-click-modal="false"  title="編輯" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				
      <el-form :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
        <el-table :data="form.data_info" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column align="center" prop="title" label="題目">
					<template slot-scope="scope">
						<div v-if="scope.row.title.length > 20">
							{{ scope.row.title.substring(0, 20) }}... 
							<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
						</div>
						<div v-else>
							{{ scope.row.title }}
						</div>
					</template>
				</el-table-column>

                  <el-table-column align="center" prop="difficulty" label="難度"></el-table-column>
                  <el-table-column align="center" prop="score" label="分數"></el-table-column>
                  <el-table-column align="center" prop="topic_type" label="類型" width="100">
                    <template slot-scope="scope">
                        <span :style="{ color: formatValue('topic_type', scope.row.topic_type).color }">
                            {{ formatValue('topic_type', scope.row.topic_type).label }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="get_score" label="獲得分數">
                  <template slot-scope="scope">
                    <span v-if="scope.row.topic_type !== 3">{{scope.row.status == 1 ? '10' : '0'}}</span>
                    <span v-else-if="scope.row.get_score && scope.row.topic_type == 3">{{scope.row.get_score}}</span>
                    <span v-else style="color: red;">未打分</span>
                  </template>
                </el-table-column>
									<el-table-column prop="id" align="center" width="100" label="操作">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="getScore(scope.row, scope.$index)">打分</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
      </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

    <el-dialog :close-on-click-modal="false"  title="打分" :visible.sync="createScoreModel" top="5vh" :width="layout.is_phone?'90%':'80%'" @opened="focusScoreInput">
		<div style="max-height: 65vh; overflow: auto;">
			<el-form ref="topForm" :rules="rulesTag" :model="topForm" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
			<el-form-item label="題目图片" prop="icon" v-if="topForm.img_url">
			<div class="demo-image__preview">
				<el-image
				style="width: 100px; height: 100px"
				:src="topForm.img_url" 
				:preview-src-list="topForm.img_url">
				</el-image>
			</div>
			</el-form-item>
		
			<el-descriptions title="題目信息" direction="vertical" :column="3" border style="margin-bottom: 30px;">
				<el-descriptions-item label="題目">{{topForm.title}}</el-descriptions-item>
				<el-descriptions-item label="難度">{{topForm.difficulty}}</el-descriptions-item>
				<el-descriptions-item label="最大分數">{{topForm.score}}</el-descriptions-item>
			</el-descriptions>

				<el-form-item label="提交的答案" >
					<div class="demo-image__preview">
						<el-image style="width: 400px; height: 400px" v-for="url in topForm.upload_url" :key="url" :src="url" :preview-src-list="topForm.upload_url" lazy></el-image>
					</div>
				</el-form-item>

				<el-form-item label="得分" prop="set_score">
					<el-input 
					ref="scoreInput" 
					type="number" 
					v-model="topForm.set_score" 
					placeholder="0" 
					size="small" 
					style="width: 85%;">
					</el-input>
				</el-form-item>
			</el-form>
		</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createScoreModel = false">取 消</el-button>
				<el-button type="primary" @click="submitScor">打 分</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="比賽">
			<p>{{ fullTitle }}</p>
		</el-dialog>

    <!-- 弹出框，用于顯示完整題目 -->
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" title="比賽">
		<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		props: ['com_id'],  // 接收傳递的參數
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogTitleVisible: false,
				fullTitle: '',

				search:{},
				dialogVisible: false,
				createScoreModel:false,
				fullTitle: '',

				dialogVisible: false,
				selectedRow: {},
				tableData: [],
				topForm: {}, 
				form: {}, 
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					topic_no: '',
					is_check_status: 0,
					name: '',
				},
				
        		topFormIndex: null,  // 用于存储當前打分项的索引
				auth_val: 'editTopicList',
				preUrl: "user/editTopicList", //列表地址
				addUrl: "user/editTopic", //添加/修改地址
				delUrl: "user/delShop", //删除單条地址
				delAllUrl: "user/delShopAll", //批量删除地址
				editStatusUrl:"user/editStatusSchoolAdmin",//修改狀態地址
				rule_list: [],
				address_list:[],
				check_img_list:[],
        		rulesTag: {
					set_score: [{
						required: true,
						message: "分數不能為空",
						trigger: 'blur',
					}, {
						validator: (rule, value, callback) => {
							if (value === '' || value < 0 ) {
								callback(new Error('分數不能小於0或大於最大分數'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}],
				},
			}
		},
		created() {
			if (this.com_id) {
				this.search.com_id = this.com_id;
			}
			this.commonList(['address_list']);
			
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
       		// 顯示完整題目内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogVisible = true;
			},
            openDialog(row) {
                this.selectedRow = row;
                this.dialogVisible = true;
            },
            // 將秒數轉為直觀時間：如 1小時30分20秒、20分10秒
            formatUseTime(seconds) {
                const n = parseInt(seconds, 10);
                if (isNaN(n) || n < 0) return '0秒';
                const h = Math.floor(n / 3600);
                const m = Math.floor((n % 3600) / 60);
                const s = n % 60;
                const parts = [];
                if (h > 0) parts.push(h + '小時');
                if (m > 0) parts.push(m + '分');
                parts.push(s + '秒');
                return parts.join('');
            },
            formatValue(type, value) {
                const mappings = {
                    type: { 
                        labels: { 1: '報名', 2: '購買獎品' }, 
                        colors: { 1: '#409EFF', 2: '#67C23A' } // Blue, Green
                    },
                    topic_type: { 
                        labels: { 1: '選擇題', 2: '填空題', 3: '上傳題' },
                        colors: { 1: '#909399', 2: '#409EFF', 3: '#67C23A' } // Gray, Blue, Red, Orange
                    },
                    status: { 
                        labels: { 1: '回答正確', 2: '回答錯誤', 3: '未做打' },
                        colors: { 2: '#F56C6C', 1: '#67C23A', 3: '#909399' } // Red, Green, Gray, Orange, Blue
                    }
                };

                const label = mappings[type]?.labels[value] || '未知';
                const color = mappings[type]?.colors[value] || '#909399';

                return { label, color };
            },
				
			//打分數
			getScore(item){
				this.editIndex = item.id;
				this.topForm = { ...item.data };  // 克隆數据项到 topForm，避免直接引用
				// this.topForm['set_score'] = Number(item['set_score'] || 0);
				console.log(this.topForm)
				this.createScoreModel = true;
			},
			submitScor() {
				this.$refs.topForm.validate(valid => {
					if (valid) {
						this.form.data = this.topForm;
						console.log(this.form.data)
						this.form.id = this.editIndex
						// 检查是否存在未评分的題目
						this.addOrEdit(this.form,true)
						// 重新赋值整个數組，触发 Vue 的响应式更新
						this.createScoreModel = false;  // 關閉评分弹窗
					}
				});
			},
			// 打开模态框
			openModel(e = false, type = 3) {
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					data_info: e.row.data,
				};
				this.editIndex = e.row.id;
					// 正常打開表單編輯模式
					this.createModel = true;
			},
			focusScoreInput() {
				// if (this.topForm.topic_type === 3) { // 判断是否为需要得分輸入的類型
				// this.$nextTick(() => {
				// 	if (this.$refs.scoreInput) {
				// 	this.$refs.scoreInput.focus(); // 设置輸入框聚焦
				// 	}
				// });
				// }
			},
			//提交
			submit() {
					this.form.id = this.editIndex
							// 检查是否存在未评分的題目
					const unscoredItem = !this.form.data.get_score;

					if (unscoredItem) {
					// 如果存在未评分的題目，弹出提示
					this.$message({
						message: '存在未打分的題目，請完成评分後再提交',
						type: 'warning'
					});
					return; // 阻止提交操作
					}
					this.addOrEdit(this.form,true)
			},

			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.address_list = all.data.list.address

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
      //大分
     
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					topic_no: '',
					is_check_status: 0,
					name: '',
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
